import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'

const query = gql`
  mutation ALMACEN_ELIMINAR($codigoAlmacen: String!) {
    almacenEliminar(codigoAlmacen: $codigoAlmacen)
  }
`

export const apiAlmacenEliminar = async (codigoAlmacen: string): Promise<boolean> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)

  const data: any = await client.request(query, { codigoAlmacen })
  return data.almacenEliminar
}
